import { ChatRoomType } from 'features/chat/types';
import { clevertapEvent } from 'utils/clevertap';

const roomTypeValue: Record<ChatRoomType, string> = {
  ROOM_TYPE_PERSONAL: 'Personal',
  ROOM_TYPE_GROUP: 'Group',
  ROOM_TYPE_BROADCAST: 'Broadcast',
};

// Action
export const trackGroupAutoShare = (
  roomId: string,
  isAdmin: boolean,
  isAutoShareOn: boolean,
) => {
  clevertapEvent('Group Chat Action', {
    Action: 'Group Chat Auto-Share Trade Selected',
    'Room ID': roomId,
    'Member Type': isAdmin ? 'Admin' : 'Non Admin',
    'Auto Share': isAutoShareOn ? 'On' : 'Off',
  });
};

export const trackAllowMemberShareTrade = (
  roomId: string,
  isAutoShareOn: boolean,
) => {
  clevertapEvent('Group Chat Action', {
    Action: 'Group Chat Allow Member Share Trade Selected',
    'Room ID': roomId,
    'Enable Member Share': isAutoShareOn ? 'On' : 'Off',
  });
};

export const trackMemberActivateNow = (roomId: string) => {
  clevertapEvent('Share Trade Action', {
    Action: 'Member Activate Now Selected',
    'Room ID': roomId,
  });
};

export const trackConfirmedMemberAutoShare = (roomId: string) => {
  clevertapEvent('Share Trade Action', {
    Action: 'Confirmed Member Auto-Share',
    'Room ID': roomId,
  });
};

export const trackChatCompanySymbol = (
  roomId: string,
  messageId: string,
  symbol: string,
  orderStatus: string,
  roomType: ChatRoomType,
) => {
  clevertapEvent('Share Trade Action', {
    Action: 'Chat Company Symbol Selected',
    'Room ID': roomId,
    'Message ID': messageId,
    Symbol: symbol,
    'Order Status': orderStatus,
    'Chat Room Type': roomTypeValue[roomType],
  });
};

export const trackChatPreviousOrder = (
  roomId: string,
  messageId: string,
  symbol: string,
  orderStatus: string,
  roomType: ChatRoomType,
) => {
  clevertapEvent('Share Trade Action', {
    Action: 'Chat See Previous Order Company Symbol Selected',
    'Room ID': roomId,
    'Message ID': messageId,
    Symbol: symbol,
    'Order Status': orderStatus,
    'Chat Room Type': roomTypeValue[roomType],
  });
};
